import "./shared/lang/i18n";
import AppProviders from "./app/providers/AppProviders";
import { Navigation } from "./app/routes/Navigation";
import { ColocaToaster } from "./shared/components/feedback/ColocaToast";
import { PwaUpdatePrompt } from "./shared/pwa/PwaUpdatePrompt";

function App() {
  return (
    <AppProviders>
      <div
        className={`body-font font-inter dark:bg-zinc-900 bg-white
      dark:text-white w-full min-h-screen transition duration-200 accent-green-500 dark:accent-green-300
      selection:text-white selection:bg-green-500/70 dark:selection:bg-green-500/60`}
      >
        <Navigation />
        <ColocaToaster />
        <PwaUpdatePrompt />
      </div>
    </AppProviders>
  );
}

export default App;
